export enum CookieBannerType {
    Default = 0,
    CartItemNotification = 1,
}